const Words = [

'câlice',
'calice',
'caliss',
'calvaire',
'criss', ,
'maudit',
'osti', ,
'ostie',
'sacrament',
'simonaque',
'tabarnak',
'torrieu',
'viarge',
'ciboire',
'siboire',
'xxx',
'niquer',
'empapaouter',
'enculer',
'foutre',
'archifoutre',
'asphalteuse',
'chatte',
'merde',
'bite',
'pine',
'bagouse',
'baisable',
'baise',
'baiser',
'baiseur',
'bander',
'putes',
'pute',
'bat',
'bâton',
'batte',
'benzer',
'berlingue',
'biatch',
'bibite',
'biétaze',
'biffle',
'biffler',
'bifle',
'bifler',
'bitch',
'bitembois',
'blc',
'bolosser',
'sexuelle',
'bonasse',
'bonnasse',
'bordel',
'bosnioule',
'bouffable',
'bougnoul',
'bougnoule',
'bougnoulisation',
'bougnouliser',
'boukak',
'boule',
'bounioul',
'bounioule',
'bourriquer',
'branlée',
'branler',
'branlette',
'branleur',
'branlo',
'branlotter',
'brêle',
'brise',
'burnes',
'broutage',
'broute',
'minou',
'brouter',
'brouteur',
'brouteuse',
'burne',
'cagasse',
'cagoince',
'cahba',
'câliboire',
'calice',
'câlice',
'câlisse',
'câlisser',
'céoène',
'chagasse',
'chagatte',
'charmouta',
'chaude',
'pisse',
'chiant',
'chiasse',
'chiasser',
'chiatique',
'chibre',
'chiée',
'chiennasse',
'chienne',
'chiennerie',
'chier',
'chierie',
'chieur',
'chiotte',
'chiottes',
'choper',
'choune',
'christ',
'ciboire',
'claque',
'clille',
'chier',
'con',
'couilles',
'conchier',
'connard',
'connarde',
'connasse',
'conneau',
'connerie',
'contrecrisser',
'coquillard',
'couillu',
'cramouille',
'crisse',
'crissement',
'crosse',
'crosser',
'cruchasse',
'cul',
'culasse',
'culbuter',
'culer',
'culeter',
'culeur',
'débander',
'déboiter',
'décâlisser',
'décharger',
'déconnade',
'déconnage',
'décrisser',
'déculer',
'défoncer',
'défonceur',
'défourailler',
'dégager',
'déglinguer',
'dégueulassement',
'molle',
'démonter',
'dépucelage',
'dépuceler',
'désengorger',
'diarrhée',
'djoc',
'dmc',
'does',
'doeser',
'doigter',
'drisser',
'drouille',
'dtc',
'ducon',
'duconnot',
'dugland',
'éburné',
'écouillé',
'emmanché',
'emmancher',
'emmerdé',
'emmerder',
'emmerdeur',
'empapaoutage',
'enconnade',
'enconner',
'encuguler',
'enculable',
'enculade',
'enculagailler',
'enculage',
'enculailleur',
'enculatoire',
'enculé',
'enculement',
'encule',
'enculer',
'enculerie',
'enculette',
'enculeur',
'enculeuse',
'enfiler',
'enfler',
'enfoiré',
'enfoirer',
'enfourailler',
'enfoutrer',
'englander',
'engrosser',
'engueuler',
'entuber',
'envulver',
'esque',
'estie',
'exploser',
'pet',
'faciale',
'caca',
'fdp',
'fesse',
'fif',
'fifi',
'pédés',
'garce',
'race',
'filsdeputerie',
'fion',
'fiotte',
'fister',
'flûte',
'foirade',
'foufoune',
'foufounette',
'foune',
'fourbir',
'fourrer',
'fouteur',
'foutoir',
'foutre',
'foutriquer',
'froc',
'fuck',
'fucker',
'gland',
'glaoui',
'gnasse',
'gniouf',
'gnoul',
'gnoule',
'gosse',
'gougnote',
'gougnoter',
'gourdin',
'gousse',
'graine',
'gros',
'grouille',
'gueule',
'gueuler',
'imbaisable',
'imbitable',
'latter',
'limer',
'lopette',
'merde',
'marde',
'maquerellage',
'matos',
'mazouter',
'merdasse',
'merder',
'merderie',
'merdeux',
'merdicité',
'merdier',
'merdogène',
'quenelle',
'mijole',
'minou',
'morue',
'motocultable',
'motoculter',
'mouille',
'mouiller',
'moule',
'mouron',
'pisser',
'foutre',
'nique',
'ntm',
'nul',
'nulach',
'pachole',
'pd',
'zob',
'pédale',
'pédé',
'pédoque',
'peler',
'pélot',
'pépom',
'pet',
'pine',
'piner',
'pinocumettable',
'pinocumettre',
'pipe',
'pisser',
'pisseur',
'plotte',
'poche',
'pogne',
'pomper',
'porc',
'pougner',
'poutrer',
'pqr',
'putain',
'pute',
'queue',
'queutard',
'rab',
'radasse',
'ramoner',
'ras',
'touffe',
'réempaffer',
'réenculer',
'refucker',
'riflard',
'rondelle',
'roubignole',
'roupette',
'salaud',
'salopard',
'salope',
'sex',
'sexy',
'sexe',
'sexes',
'schleu',
'schnek',
'shit',
'souchien',
'sucer',
'suce',
'taboune',
'tafiole',
'tantouze',
'tapette',
'tapettitude',
'tapiole',
'tarlouze',
'tartissure',
'taspé',
'tassepé',
'tâter',
'tbm',
'techa',
'tepu',
'teub',
'teuch',
'teucha',
'tg',
'touffe',
'troncher',
'trouduc',
'trouducune',
'troufignon',
'truie',
'turluchon',
'turlutte',
'valseuse',
'vdm',
'vieille',
'vier',
'yeule',
'youp',
'youpin',
'youpine',
'zboob',
'zboube',
'zguègue',
'saloperie',
'sucks',
'sucker',
'gode',
'blairot',
'fist',
'sperme',
'facial',
'ejaculer',
'ejaculation',
'gun',
'gumshot',
'ejac',
'vulve',
'anale',
'anus',
'penis',
'sodomie',
'sodomite',
'sado',
'sodomies',
'sodomites',
'levrette',
'kamasutra',
'blowjob',
'zizi',
'cunni',
'cunnilingus',
'rael',
'bit',
'cocaine',
'coke',
'sexuel',

]

export { Words }










// WEBPACK FOOTER //
// ./src/components/jeu1/js/Words.js